import { CurrencyType } from 'api/types/entity';
import { formatPrice, parsePrice } from 'helpers';
import { Autocomplete, InputProps, NumberInput, Stack } from 'libs/ui';

import { FieldType } from '../types';
import { useField } from '../useField';

import { CurrencyContainer } from './PriceAndCurrencyField.styles';

export interface TextFieldProps
  extends FieldType,
    Omit<InputProps, 'name' | 'onChange' | 'onChangeText' | 'value'> {}

export interface PriceFieldValue {
  price: number;
  currency: CurrencyType;
}

/**
 * Price and currency field.
 */
export const PriceAndCurrencyField = ({
  name,
  allowSubmit,
  readOnly,
  ...props
}: TextFieldProps) => {
  const priceName = `${name}.price`;
  const currencyName = `${name}.currency`;

  const { field, helpers, inputProps } = useField<number | undefined>(
    priceName
  );

  const {
    field: fieldCurrency,
    helpers: helpersCurrency,
    inputProps: inputPropsCurrency,
  } = useField<CurrencyType | undefined>(currencyName);

  const isError = inputProps.error || inputPropsCurrency.error;
  const helperText = inputProps.helperText || inputPropsCurrency.helperText;

  return (
    <Stack direction="row" spacing={24}>
      <NumberInput
        {...props}
        fullWidth
        error={isError}
        format={formatPrice}
        helperText={helperText}
        name={name}
        parse={parsePrice}
        readOnly={readOnly || inputProps.readOnly}
        value={field.value}
        onBlur={field.onBlur(name)}
        onChange={() => {
          helpersCurrency.setError('');
          helpers.setError('');
        }}
        onChangeText={(v) => {
          helpers.setValue(v);
        }}
        onClear={() => helpers.setValue(undefined)}
      />
      <CurrencyContainer>
        <Autocomplete
          className="priceField-Currency"
          error={isError}
          fullWidth={false}
          label=" "
          name={currencyName}
          optionLabelKey="label"
          options={Object.values(CurrencyType).map((v) => ({
            value: v,
            label: v,
          }))}
          optionValueKey="value"
          readOnly={readOnly || inputProps.readOnly}
          value={
            fieldCurrency.value
              ? { value: fieldCurrency.value, label: fieldCurrency.value }
              : null
          }
          variant="select"
          onChange={(v) => {
            helpers.setError('');
            helpersCurrency.setError('');
            helpersCurrency.setValue(v?.value);
          }}
        />
      </CurrencyContainer>
    </Stack>
  );
};
